import { gqlSend } from '../store/gql/send'
import { GET_MINIMUM } from '../store/gql/minimum'

export const appFetchDurationAPI = async () => {
  const variables = {
    key: 'hrms_setting_leave_duration_step',
  }

  return await gqlSend({
    query: GET_MINIMUM,
    req: variables,
  })
}
